import { render, staticRenderFns } from "./newZlAssess.vue?vue&type=template&id=1e1ce40c&scoped=true"
import script from "./newZlAssess.vue?vue&type=script&lang=js"
export * from "./newZlAssess.vue?vue&type=script&lang=js"
import style0 from "./newZlAssess.vue?vue&type=style&index=0&id=1e1ce40c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1ce40c",
  null
  
)

export default component.exports